module.exports = __webpack_public_path__ + "img/storage-room.df22af4b.svg";